export default "__VITE_ASSET__d6661455__"